import { useState } from "react";
import { campaigns } from "../../../mocks/campaigns";

export default function BusinessCampaignsSection() {
  const myCampaigns = campaigns.slice(0, 2);
  const [showAddForm, setShowAddForm] = useState(false);
  const [addSaved, setAddSaved] = useState(false);

  const handleAdd = (e: React.FormEvent) => {
    e.preventDefault();
    setAddSaved(true);
    setTimeout(() => { setAddSaved(false); setShowAddForm(false); }, 2000);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-semibold text-stone-800">Kampanyalarım</h2>
          <p className="text-sm text-stone-400 mt-0.5">{myCampaigns.length} aktif kampanya</p>
        </div>
        <button
          onClick={() => setShowAddForm(!showAddForm)}
          className="flex items-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-add-line" /> Yeni Kampanya
        </button>
      </div>

      {/* Add Form */}
      {showAddForm && (
        <form data-readdy-form onSubmit={handleAdd} className="bg-white rounded-2xl border border-emerald-200 p-5">
          <h3 className="font-semibold text-stone-800 mb-4 flex items-center gap-2">
            <i className="ri-coupon-line text-emerald-600" /> Yeni Kampanya Oluştur
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs text-stone-500 mb-1.5">Kampanya Başlığı *</label>
              <input name="title" type="text" required placeholder="Ör: Öğle Yemeğinde %20 İndirim"
                className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400" />
            </div>
            <div>
              <label className="block text-xs text-stone-500 mb-1.5">İndirim Oranı (%) *</label>
              <input name="discount" type="number" min="1" max="100" required placeholder="20"
                className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400" />
            </div>
            <div>
              <label className="block text-xs text-stone-500 mb-1.5">Kupon Kodu *</label>
              <input name="coupon_code" type="text" required placeholder="ISKENDER20"
                className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400" />
            </div>
            <div>
              <label className="block text-xs text-stone-500 mb-1.5">Son Geçerlilik Tarihi *</label>
              <input name="expires_date" type="date" required
                className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400 cursor-pointer" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-xs text-stone-500 mb-1.5">Açıklama</label>
              <textarea name="description" rows={3} placeholder="Kampanya koşullarını açıklayın..." maxLength={500}
                className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400 resize-none" />
            </div>
          </div>
          <div className="flex gap-3 mt-4">
            <button type="button" onClick={() => setShowAddForm(false)}
              className="flex-1 py-2.5 border border-stone-200 rounded-xl text-sm text-stone-600 hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap">
              İptal
            </button>
            <button type="submit"
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${addSaved ? "bg-emerald-600 text-white" : "bg-emerald-700 hover:bg-emerald-800 text-white"}`}>
              {addSaved ? "✓ Oluşturuldu!" : "Kampanyayı Oluştur"}
            </button>
          </div>
        </form>
      )}

      {/* Existing campaigns */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {myCampaigns.map((camp) => (
          <div key={camp.id} className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
            <div className="relative h-36 overflow-hidden">
              <img src={camp.image} alt={camp.title} className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 rounded-full bg-amber-500 text-white text-xs font-bold">%{camp.discountPct} İNDİRİM</span>
              </div>
              <div className="absolute bottom-3 left-3">
                <p className="text-white font-bold text-sm">{camp.title}</p>
              </div>
            </div>
            <div className="p-4">
              <p className="text-stone-500 text-xs mb-3 line-clamp-2">{camp.description}</p>
              <div className="flex items-center justify-between text-xs text-stone-500 mb-3">
                <span><i className="ri-time-line mr-1" />Son: <strong>{camp.expiresDate}</strong></span>
                <span className="font-mono font-bold text-stone-700 tracking-wider">{camp.couponCode}</span>
              </div>
              <div className="flex gap-2">
                <button className="flex-1 py-2 border border-stone-200 rounded-xl text-xs font-medium text-stone-600 hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-1">
                  <i className="ri-edit-line" /> Düzenle
                </button>
                <button className="flex-1 py-2 border border-amber-200 rounded-xl text-xs font-medium text-amber-600 hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-1">
                  <i className="ri-pause-line" /> Durdur
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* Empty state */}
        {myCampaigns.length === 0 && (
          <div className="md:col-span-2 bg-white rounded-2xl border border-dashed border-stone-200 p-14 text-center">
            <i className="ri-coupon-line text-4xl text-stone-200 block mb-3" />
            <p className="font-medium text-stone-600 mb-1">Henüz kampanya yok</p>
            <p className="text-sm text-stone-400">Yeni Kampanya butonuna tıklayarak başlayın.</p>
          </div>
        )}
      </div>

      {/* Info box */}
      <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-4 flex items-start gap-3">
        <i className="ri-information-line text-emerald-600 text-lg mt-0.5" />
        <div className="text-sm text-emerald-800">
          <strong>Sponsorlu kampanyalar</strong> ana sayfada öne çıkar ve daha fazla ziyaretçiye ulaşır.
          Sponsorlu içerik almak için <strong>Reklam Ver</strong> bölümünü ziyaret edin.
        </div>
      </div>
    </div>
  );
}
